
export abstract class AppConstants {

  static readonly LOAD_PLANNING = 'Load Planning';
  static readonly CLOSEOUT = 'Closeout';
  static readonly LOAD_PLANNING_CODE = 'LDPL';
  static readonly CLOSEOUT_CODE = 'CLST';
  static readonly STATUS_DATA_UNAVAILABLE = 'DATA UNAVAILABLE';
  static readonly CLST_YET_TO_START = 'PROCESSING YET TO START';
  static readonly CLST_PROCESSED = 'PROCESSED CLOSEOUT';
  static readonly CLST_PROCESSING_REOPENED = 'PROCESSING REOPENED';
  static readonly LDPL_TRIGGER_YET_TO_START = 'TRIGGER YET TO START';
  static readonly LDPL_TRIGGER_DELAYED = 'TRIGGER INITIATION DELAYED';
  static readonly LDPL_DATA_RECEIVED = 'DATA RECEIVED';
  static readonly LDPL_NOT_BALANCED = 'NOT BALANCED';
  static readonly TIME_ZONE_GMT = 'gmt';
  static readonly TIME_ZONE_LOCAL = 'local';
  static readonly DDMMYYYY_FORMAT = 'DD-MMM-YYYY';
  static readonly FWD_SLASH = '/';
  static readonly APP_NAMES: string[] = [ AppConstants.LOAD_PLANNING, AppConstants.CLOSEOUT ];
  static readonly CNFG_ENVT_LOCAL = 'localhost';
  static readonly CNFG_ENVT_DEV = 'dev';
  static readonly CNFG_ENVT_SI = 'si';
  static readonly CNFG_ENVT_PROD = 'prod';
  static readonly ENVT_LOCAL = 'Local';
  static readonly ENVT_DEV = 'Development';
  static readonly ENVT_SI = 'Integration';
  static readonly ENVT_PROD = 'Production';
}
